import fscreen from 'fscreen';
import { useState, useEffect } from 'react';

export type Fullscreen = {
  enabled: boolean;
  enable: () => void;
  disable: () => void;
  available: boolean;
};

const useFullscreen = (): Fullscreen => {
  const [enabled, setEnabled] = useState(false);

  const available = fscreen.fullscreenEnabled;

  const enable = () => {
    fscreen.requestFullscreen(document.documentElement);
  };

  const disable = () => {
    fscreen.exitFullscreen();
  };

  useEffect(() => {
    const changed = () => {
      setEnabled(fscreen.fullscreenElement !== null);
    };

    fscreen.addEventListener('fullscreenchange', changed);

    return () => {
      if (enabled) disable();
      fscreen.removeEventListener('fullscreenchange', changed);
    };
  }, []);

  return {
    enabled,
    enable,
    disable,
    available,
  };
};

export default useFullscreen;
